import { getDoc, doc } from "firebase/firestore"
import { db } from '@/firebase/config'
import { MILUIM_COORDINATOR_FIELD } from '@/constants/helpTypes'

export const verifyAdmin = async (uid) => {
    const userDocRef = doc(db, "users", uid);
    const userDocSnap = await getDoc(userDocRef);
    if (userDocSnap.data().isAdmin) {
        return true
    } else {
        return false
    }
}

// Points-manager access: "pure" admins (not coordinators) or miluim-family coordinators.
// A plain isAdmin check restricts nobody because coordinators are auto-granted isAdmin.
export const canManagePoints = (userData) => {
    if (!userData) return false
    if (userData.isAdmin && !userData.isCoordinator) return true
    return (userData.coordinatorFields || []).includes(MILUIM_COORDINATOR_FIELD)
}

export const verifyPointsManager = async (uid) => {
    const userDocRef = doc(db, "users", uid);
    const userDocSnap = await getDoc(userDocRef);
    return canManagePoints(userDocSnap.data())
}
